import { c as _c } from "react/compiler-runtime";
import type { InterfaceInputToken, Point, Rewards } from '@morpho-org/dapp-core';
import { DataList } from '@morpho-org/ui-v6/client';
import { formatters } from '@morpho-org/ui-v6/utils';
import type { MerklTarget } from '@/components/common/RewardsHoverCard/MerklRewardsHoverCard';
import { IconRewardHover } from '@/components/common/IconRewardHover';
export interface InstantApyDataLineProps {
  apy?: bigint | null;
  netApy?: bigint | null;
  rewards: Rewards[];
  points: Point[];
  asset?: InterfaceInputToken | null;
  merklContext?: MerklTarget | null;
  performanceFee?: bigint | null;
}
const InstantApyDataLine = t0 => {
  const $ = _c(16);
  const {
    apy,
    netApy,
    rewards,
    points,
    asset,
    merklContext,
    performanceFee
  } = t0;
  let t1;
  if ($[0] !== netApy) {
    t1 = formatters.percent.default("-").unit("%").trailingZero(true).digits(2).of(netApy, 18);
    $[0] = netApy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedInstantValue = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DataList.LeftItem label="Instant APY" tooltip="Instant vault net APY, including fees and rewards." />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== apy || $[4] !== asset || $[5] !== netApy || $[6] !== performanceFee || $[7] !== points || $[8] !== rewards) {
    t3 = {
      apy,
      rewards,
      points,
      variant: "vault",
      netApy,
      asset,
      durationText: "Instant",
      performanceFee
    };
    $[3] = apy;
    $[4] = asset;
    $[5] = netApy;
    $[6] = performanceFee;
    $[7] = points;
    $[8] = rewards;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== formattedInstantValue) {
    t4 = <div className="flex"><span className="text-foreground text-xs">{formattedInstantValue}</span></div>;
    $[10] = formattedInstantValue;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== merklContext || $[13] !== t3 || $[14] !== t4) {
    t5 = <DataList.Line>{t2}<DataList.RightItem><IconRewardHover RewardsHoverCardProps={t3} merklContext={merklContext}>{t4}</IconRewardHover></DataList.RightItem></DataList.Line>;
    $[12] = merklContext;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default InstantApyDataLine;